<script setup lang="ts">
import {Head, router, useForm} from "@inertiajs/vue3";
import AuthLayout from "@/layouts/AuthLayout.vue";
import {route} from "ziggy-js";
import VFieldLabel from "@/components/forms/VFieldLabel.vue";
import {onMounted, onUnmounted} from "vue";

defineOptions({layout: AuthLayout})

let interval: ReturnType<typeof setInterval>;

const requestLink = () => {
    router.post(route('verification.send'))
}



onMounted(() => {
    interval = setInterval(() => {
        router.reload();
    }, 30000);
});

onUnmounted(() => {
    clearInterval(interval);
});
</script>

<template>
    <Head title="Verify Email ⋅ Capacity Framework Portal" />
    <v-card
        variant="flat"
        class="justify-center"
    >
        <v-card-title class="text-center text-h4 text-pre-wrap">
            <p>
                Verify your email address
            </p>
            <p class="text-h5 text-medium-emphasis">
                Once you have verified your email address, you will be able to log in and get started.
            </p>
        </v-card-title>
        <p class="text-body-2 text-center mt-3">
            Didn't receive an email? <span
                class="text-primary custom-link"
                @click="requestLink"
            >
                Resend email
            </span>
        </p>
    </v-card>
</template>

<style scoped>

</style>
